import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-759ddb53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column login-container" }
const _hoisted_2 = { class: "flex1 login-container__box" }
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = { class: "login-box" }
const _hoisted_5 = { class: "cross-center" }
const _hoisted_6 = { class: "forget-password" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 忘记密码？ ")
const _hoisted_8 = { class: "cross-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "login-veri",
  class: "hidden"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "勾选即代表您已阅读并同意", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 登录 ")
const _hoisted_13 = { class: "right-center other-action" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "还没有账号？", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 立即注册 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SendVeriButton = _resolveComponent("SendVeriButton")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BaseLayoutFooter = _resolveComponent("BaseLayoutFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass([
                'center-center',
                'flex1',
                'cursor-pointer',
                'type-item',
                { 'is-active': _ctx.formData.authorization_type === 'mobile' },
              ]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLoginType('mobile')))
            }, " 密码登录 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass([
                'center-center',
                'flex1',
                'cursor-pointer',
                'type-item',
                { 'is-active': _ctx.formData.authorization_type === 'smsotp' },
              ]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLoginType('smsotp')))
            }, " 短信登录 ", 2)
          ]),
          _createVNode(_component_el_form, {
            ref: "loginForm",
            class: "login-form",
            model: _ctx.formData,
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "mobile" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    class: "sys-input",
                    placeholder: "请输入手机号",
                    modelValue: _ctx.formData.mobile,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.mobile) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.formData.authorization_type === 'mobile')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    class: "password-form-item",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "sys-input",
                        type: "password",
                        placeholder: "请输入密码",
                        modelValue: _ctx.formData.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.password) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_router_link, {
                          class: "base-link",
                          to: "/client/forget-password"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.formData.authorization_type === 'smsotp')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    prop: "mobile_code"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_el_input, {
                          class: "sys-input very-input",
                          placeholder: "请输入验证码",
                          modelValue: _ctx.formData.mobile_code,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.mobile_code) = $event))
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_SendVeriButton, {
                              veriBtnType: "text",
                              class: "very-btn",
                              sendType: "oneAccount",
                              beforeSend: _ctx.sendVeriMessage
                            }, null, 8, ["beforeSend"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _hoisted_9
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                class: _normalizeClass([{ 'negotiate-item': !_ctx.checkPrivatePolicyIsError }]),
                prop: "checkPrivatePolicy"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "cross-center cursor-pointer check-policy",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (
                  _ctx.formData.checkPrivatePolicy = !_ctx.formData.checkPrivatePolicy
                ))
                  }, [
                    _createVNode(_component_el_radio, {
                      disabled: "",
                      class: "spacie-radio",
                      label: true,
                      modelValue: _ctx.formData.checkPrivatePolicy,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.checkPrivatePolicy) = $event)),
                      style: {"margin-right":"0"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _hoisted_11,
                    _createElementVNode("span", {
                      class: "base-link",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openDialog && _ctx.openDialog(...args)), ["stop"]))
                    }, " 《中通快递隐私政策》 ")
                  ])
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "full-btn",
            disabled: _ctx.loginLoading,
            onClick: _ctx.loginAction
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_router_link, {
              class: "base-link",
              to: "/client/register"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_BaseLayoutFooter, { showFooterMenu: false })
  ]))
}